module.exports = __webpack_public_path__ + "static/media/plus-down.e384707a.svg";